import React from 'react';
import { useDataProvider, useRefresh } from 'react-admin';
import { Form } from 'react-final-form';
import { FORM_ERROR } from 'final-form';

import { Dialog } from 'components/common';
import { Input } from 'components/form';
import { AchTierConfigDto } from '../types';

interface Props {
  record: AchTierConfigDto;
  open: boolean;
  onClose: () => void;
}

interface FormValues {
  instantAvailabilityCapCents: number;
  minSuccessfulClearancesToPromote: number;
}

const EditTierDialog = ({ record, open, onClose }: Props) => {
  const dataProvider = useDataProvider();
  const refresh = useRefresh();

  const handleSubmitForm = async (values: FormValues) => {
    try {
      const { data } = await dataProvider.update('achTiers', {
        data: {
          tier: record.tier,
          ...values,
        },
      });

      refresh();
      onClose();

      return data;
    } catch (error: any) {
      return { [FORM_ERROR]: error.message ?? error };
    }
  };

  return (
    <Form<FormValues>
      initialValues={{
        instantAvailabilityCapCents: record.instantAvailabilityCapCents,
        minSuccessfulClearancesToPromote: record.minSuccessfulClearancesToPromote,
      }}
      onSubmit={handleSubmitForm}
      render={({ handleSubmit, submitting, submitError }) => {
        return (
          <form onSubmit={handleSubmit}>
            <Dialog
              open={open}
              onCancel={onClose}
              title="Edit tier"
              onConfirm={handleSubmit}
              confirmText="Save"
              submitting={submitting}
              error={submitError}>
              <Input name="instantAvailabilityCapCents" label="Instant availability cap" />
              <Input name="minSuccessfulClearancesToPromote" label="Min successful clearances" />
            </Dialog>
          </form>
        );
      }}
    />
  );
};

export default EditTierDialog;
